import { Link } from 'react-router'

export default function AboutPage() {
  return (
    <div>
      <h2>AboutPage</h2>
      <Link to='/error-page'>Go to Error Page</Link>
    </div>
  )
}
